import { render, staticRenderFns } from "./ButtonWhite.vue?vue&type=template&id=6e0b47c8&scoped=true"
import script from "./ButtonWhite.vue?vue&type=script&lang=js"
export * from "./ButtonWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b47c8",
  null
  
)

export default component.exports